<template>
  <div id="business-edit-tab-places">
    <!-- Places Table -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <!-- Col Header -->
        <div class="flex items-end">
          <feather-icon icon="UserIcon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium">{{ $t('places.places') }}</span>
        </div>
        <vs-table ref="table" :data="dataLocal.places" class="vs-table places-table mt-4">
          <template slot="thead">
            <vs-th sort-key="alias">{{ $t('places.alias') }}</vs-th>
            <vs-th sort-key="subject">{{ $t('places.subject') }}</vs-th>
            <vs-th sort-key="category">{{ $t('places.category') }}</vs-th>
            <vs-th sort-key="state">{{ $t('entity.state') }}</vs-th>
            <vs-th sort-key="status">{{ $t('places.status') }}</vs-th>
            <vs-th sort-key="province">{{ $t('users.addresses.address') }}</vs-th>
            <vs-th>{{ $t('forms.actions') }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody v-if="data.length">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="tr.alias">
                  {{ tr.alias }}
                </vs-td>
                <vs-td :data="tr.subject">
                  {{ $t(`places.subjects.${tr.subject}`) }}
                </vs-td>
                <vs-td :data="tr.category">
                  {{ $t(`places.categories.${tr.category}`) }}
                </vs-td>
                <vs-td :data="tr.state">
                  {{ $t(`entity.states.${tr.state}`) }}
                </vs-td>
                <vs-td :data="tr.status">
                  {{ $t(`places.statuses.${tr.status}`) }}
                </vs-td>
                <vs-td>
                  <address-string :address="tr" hide-label />
                </vs-td>
                <vs-td>
                  <feather-icon
                    icon="TrashIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                    class="ml-2"
                    @click.stop="openDeleteConfirm(tr.id, indextr)"
                  />
                  <feather-icon
                    icon="EditIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                    class="ml-2"
                    @click.stop="editPlace(tr)"
                  />
                </vs-td>

                <template slot="expand">
                  <div class="w-full">
                    <div class="vx-row w-full">
                      <div class="vx-col w-full md:w-1/4">
                        <div class="font-semibold">{{ $t('users.location') }}:</div>
                        <div>{{ $t('users.lat') }}: {{ tr.location.lat }}</div>
                        <div>{{ $t('users.lon') }}: {{ tr.location.lon }}</div>
                      </div>
                      <div class="vx-col w-full md:w-3/4">
                        <open-street-map
                          view-only
                          :markers="[{ latlng: tr.location }]"
                          :zoom="15"
                          disable-fit
                          :center="tr.location"
                        />
                      </div>
                    </div>
                    <div class="vx-row w-full" v-if="tr.description">
                      <div class="vx-col">
                        <div class="font-semibold mt-2">{{ $t('places.description') }}:</div>
                        <div>{{ tr.description }}</div>
                      </div>
                    </div>
                  </div>
                </template>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </div>
    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" color="success" @click="addPlace">
            {{ $t('forms.add') }}
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddressString from '@/views/components/maps/AddressString'
import modulePlaces from '@/store/places/modulePlaces'
import OpenStreetMap from '@/views/components/maps/OpenStreetMap'

export default {
  name: 'BusinessEditTabPlaces',
  components: {
    OpenStreetMap,
    AddressString
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data))
    }
  },
  methods: {
    addPlace() {
      this.$router.push({ name: 'system-business-place-add', params: { businessId: this.$route.params.id } })
    },
    editPlace(place) {
      this.$router.push({
        name: 'system-business-place-edit',
        params: { businessId: this.$route.params.id, placeId: place.id }
      })
    },
    openDeleteConfirm(id, index) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('forms.delete'),
        text: this.$t('forms.are_you_sure'),
        accept: () => {
          this.$store.dispatch('place/removePlace', id).then(() => {
            this.$vs.notify({
              color: 'success',
              title: this.$t('forms.successfully_deleted')
            })
          })
          delete this.dataLocal.places.splice(index, 1)
        },
        acceptText: this.$t('button.delete'),
        cancelText: this.$t('button.cancel')
      })
    }
  },
  created() {
    if (!modulePlaces.isRegistered) {
      this.$store.registerModule('place', modulePlaces)
      modulePlaces.isRegistered = true
    }
  }
}
</script>
<style>
.vs__dropdown-menu {
  z-index: 9000;
}
.td-check.active-expanded .vs-icon {
  -webkit-transform: translate(5px) rotate(0deg) !important;
  transform: translate(5px) rotate(0deg) !important;
}
</style>
